import React, { useEffect, useState, useRef, useContext } from 'react';

import { withNamespaces } from 'react-i18next';

function SeatLayout({ t }) {
  useEffect(() => {}, []);
  return (
    <div>
      <h4>Booking Detail </h4>
    </div>
  );
}

export default withNamespaces()(SeatLayout);
